import { Node } from '@tiptap/core';

/**
 * This will let Tiptap to render <div> tags.
 */
export default Node.create({
	name: 'divNode',
	group: 'block',
	content: 'block+',

	parseHTML() {
		return [{ tag: 'div' }];
	},
	renderHTML({ HTMLAttributes }) {
		return ['div', HTMLAttributes, 0];
	},

	// Your code goes here.
});
